export default __webpack_public_path__ + "static/media/14A.030.32efa454.png";